// extracted by mini-css-extract-plugin
export default {"root":"Tab_root__VVEyM","layout-container":"Tab_layout-container__qlPTj","container":"Tab_container__tTS8z","tabContainer":"Tab_tabContainer__g3mGx","icon":"Tab_icon__vUkUv","active":"Tab_active__ThuRR","disabled":"Tab_disabled__CtPys"};
    if(module.hot) {
      // 1763446808801
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  